import { Select } from '@nazka/nazka.mapframe.components';
import { useTranslation } from '@utils/i18n/i18n';
import theme from '@css/theme.style.json';

function StyledSelect(props) {
  const { t } = useTranslation();
  
  return (
    <Select 
      {...props}
      css={{
        backgroundColor: theme.color.white,
        borderRadius: theme.layout['border-radius'].small,
        borderColor: theme.color.blue.primary,
        color: props?.value ? theme.color.black : theme.color.grey,
        '> button': {
          padding: `calc(${theme.layout.spacing} * 2) calc(${theme.layout.spacing} * 4)`,
          '&:has(+ button)': {
            paddingRight: `calc(${theme.layout.spacing} * 2)`,
          },
          '&:nth-of-type(2)': {
            padding: `0 calc(${theme.layout.spacing} * 3) 0 calc(${theme.layout.spacing} * 2)`,
          },
        },
      }}
      placeholder={t('filter_select')}
      clear
    />
  );
}

export default StyledSelect;
